import React, { useState, useEffect } from 'react'
import { useStyles } from './SouscriptionModaleStyle'
import Paiement from '../paiement/Paiement'
import { useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router-dom'

//Material UI
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Chip from '@material-ui/core/Chip'


export default function SouscriptionModale({ modale, setModale, modaleInfos: info, timeFormat, setReload, addToBasket }) {

  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const state = useSelector(state => state)
  const [formReady, setFormReady] = useState(false)
  
  const payload = {
    'amount': info.price * 100,
    'currency': 'EUR',
    'ipnTargetUrl': process.env.REACT_APP_API_PATH+'api/souscription/insert',
    'orderId':  'souscription',
    'customer': {
      'id': state.user.id,
      'numero': state.user.numero,
    },
    'metadata': {
      'liID': info.liID,
      'liMail': state.user.mail,
      'centre': info.data?.centre,
      'category': info.data?.categorie,
      'typeAbo': info.data?.typeAbo,
      'cours': info.cours?.CO_ID ?? null,
      'dateDeb': info.data?.date,
      'dateFin': info.data?.dateFin,
      'periode': info.data?.periode,
      'activity': info.cours?.CO_ACT_ID,
      'activityName': info.cours?.ACT_LIBELLE,
      'montant': info.price,
    },
  }

  async function paymentCallback(success) {
    setModale(false)
    if (success) {
      history.push('/mes-activites')
      if (setReload) setReload(new Date())
    }
  }

  function addBasket() {
    addToBasket(info)
    enqueueSnackbar(`Activité ${info.cours?.ACT_LIBELLE} ajouté au panier`, { variant: `success` })
    setModale(false)
  }

  useEffect(() => {
    setFormReady(false)
  }, [modale])

  return (
    <Dialog
      open={modale}
      onClose={() => setModale(false)}
      PaperProps={{ style: { maxWidth: 700, width: 700 } }}
    >
      <IconButton onClick={() => setModale(false)} className={classes.closeButton}>
        <CloseIcon />
      </IconButton>
      <DialogTitle >
        {info.cours?.ACT_LIBELLE}
        {info.cours?.JOUR_LIBELLE &&
          ' | Le ' + info.cours?.JOUR_LIBELLE + ' '
          + 'de ' + timeFormat(info.cours?.CO_HEUREDEBUT) + ' à ' + timeFormat(info.cours?.CO_HEUREFIN)
        }

      </DialogTitle>
      <DialogContent dividers className={classes.content}>

        <div className={classes.infos}>
          <div>
            <p>Abonné <span>{info.liLibelle}</span></p>
            <p>Centre <span>{info.centre}</span></p>
            <p>Catégorie <span>{info.categorie?.toLowerCase()}</span></p>
            <p>Type de carte <span>{info.typeAbo}</span></p>
            <p>Periode {info.periode}
              <span>
                <Chip component="span" label={
                  info.data?.date.toLocaleDateString() + ' : ' + info.data?.dateFin?.toLocaleDateString()
                } size="small" />
              </span>
            </p>

            <p>Prix <b>{info.price?.value + '€'}</b></p>
          </div>

        </div>

        <div className={classes.paiement + ' ' + (!formReady ? classes.loading : '')}>
          <h3>Paiement</h3>
          <Paiement amount={info.price * 100} callback={paymentCallback} payload={payload} onReady={() => {setFormReady(true)}}/>
          {addToBasket && 
            <Button
              disableElevation
              variant="contained"
              color="primary"
              fullWidth
              style={{ maxWidth: 400 }}
              onClick={addBasket}
            >Ajouter au panier</Button>
          }
        </div>


      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={() => setModale(false)} className={classes.cancel}>Annuler</Button>
      </DialogActions>
    </Dialog >
  )
}
